
import types from "../constants/types";

export const setCharts = payload => ({
    "type": types.SET_CHART,
    payload
});